import {get,post,url} from '../http'

class News{
    //新闻列表
    @url("/news/list") //clazz 1.头条新闻 2.综合新闻 3.专题新闻
    @get
    GetNewsList(){}

    //新闻详情
    @url("/news/one") //
    @get
    GetNewsDetail(){}
    
    //最新推荐
    @url("/news/recommend") //
    @get
    GetNewsRecommend(){}

    //上下条信息
    @url("/news/near")
    @get
    GetNear(){}

    //近期聚焦
    @url("/news/focus") //
    @get
    GetFocusList(){}

    //专题列表
    @url("/topic/list")
    @get
    GetTopicList(){}
    
    //专题详情
    @url("/topic/news")
    @get
    GetTopicNews(){}

    //学校列表
    @url("/school/list")
    @get
    getSchoolList(){}

    //学校详情
    @url("/school/detail")
    @get
    getSchoolInfo(){}

    //教师列表
    @url("/tea/list")
    @get
    getTeaList(){}

    //教师详情
    @url("/tea/one")
    @get
    getTeaInfo(){}

    //学员风采
    @url("/show/list")
    @get
    GetStudentStyle(){}

    //学员风采详情
    @url("/show/detail")
    @get
    GetStyleDetail(){}

      //学员风采上下条
    @url("/show/near")
    @get
    GetStyleNear(){}
    
}

export default new News()